/**
 * The AI manager's state for the signed-in owner (2026-09-30): is it switched
 * on for the shop, and yesterday's note (124, /api/ai-brief). ONE request per
 * shop and language per page load, shared by the accounting card and the chat
 * — both mount at once and must not ask twice.
 *
 * 1.47 (Codex's audit): keyed by the SHOP too. Signing out is an in-page
 * navigation, so this module outlives it; keyed by language alone, the next
 * owner on the same device was shown the previous shop's note.
 */

export type AiBrief = { enabled: boolean; note: string | null; day: string | null }

const cache = new Map<string, Promise<AiBrief>>()

export function loadAiBrief(lang: 'ka' | 'ru', orgId: string): Promise<AiBrief> {
  const key = `${orgId}|${lang}`
  let p = cache.get(key)
  if (!p) {
    p = fetch(`/api/ai-brief?lang=${lang}`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j: { enabled?: boolean; note?: string | null; day?: string } | null) => ({
        enabled: !!j?.enabled, note: j?.note ?? null, day: j?.day ?? null,
      }))
      .catch(() => {
        cache.delete(key)   // offline — ask again next time
        return { enabled: false, note: null, day: null }
      })
    cache.set(key, p)
  }
  return p
}
